import { Button, ModalWindow, UIHeading2, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ChatActionModal.css';
// @ts-expect-error TODO: исправить импорт картинок
import warningImg from './assets/warning.png';
import { EDeviceType } from '../../types/deviceType';

type TChatActionModalProps = {
  onCancel(): void;
  onConfirm(): void;
  text?: string;
  buttonText?: string;
  cancelButtonText?: string;
};

export const ChatActionModal: React.FC<TChatActionModalProps> = ({
  onCancel,
  onConfirm,
  text,
  buttonText,
  cancelButtonText,
}) => {
  const device = useDeviceType();
  const isMobile = device !== EDeviceType.Desktop;

  return (
    <ModalWindow open={true} onClose={onCancel} width={640} title={isMobile ? text : undefined}>
      <div data-name="ChatActionModal">
        {!isMobile && (
          <div className={styles['content']}>
            <img className={styles['icon']} src={warningImg} width={64} height={64} />
            <UIHeading2>{text}</UIHeading2>
          </div>
        )}
        <div className={styles['footer']}>
          <Button theme="fill_primary" onClick={onConfirm} size={isMobile ? 'M' : 'XS'} fullWidth={isMobile}>
            {buttonText}
          </Button>
          <Button
            theme={isMobile ? 'fill_secondary' : 'fill_white_primary'}
            onClick={onCancel}
            size={isMobile ? 'M' : 'XS'}
            fullWidth={isMobile}
          >
            {cancelButtonText || 'Отмена'}
          </Button>
        </div>
      </div>
    </ModalWindow>
  );
};
